import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { of } from 'rxjs';
import { map, take, filter, timeout, switchMap, catchError } from 'rxjs/operators';

export const adminGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService.currentUser$.pipe(
    filter(user => user !== null),
    take(1),
    timeout(10000),
    switchMap(() => authService.customClaims$.pipe(
      take(1),
      timeout(5000)
    )),
    map(claims => {
      const isAdmin = claims?.roles?.includes('admin') ?? false;
      if (!isAdmin) {
        router.navigate(['/']);
      }
      return isAdmin;
    }),
    catchError(error => {
      console.error('Admin guard: Error checking access:', error);
      router.navigate(['/']);
      return of(false);
    })
  );
};
